import { render, staticRenderFns } from "./PowerpageTab.vue?vue&type=template&id=533abf21&scoped=true&"
import script from "./PowerpageTab.vue?vue&type=script&lang=js&"
export * from "./PowerpageTab.vue?vue&type=script&lang=js&"
import style0 from "./PowerpageTab.vue?vue&type=style&index=0&id=533abf21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533abf21",
  null
  
)

export default component.exports